import '../sass/theme.scss';

import './componets/tabs-handler';

document.addEventListener('DOMContentLoaded', () => {
    console.log('Hello Theme change: ');
});